export const LOAD_DATA = 'horizon/data/LOAD_DATA'
export const LOAD_DATA_SUCCESS = 'horizon/data/LOAD_DATA_SUCCESS'
export const OPEN_SNACKBAR = 'horizon/snackbar/OPEN_SNACKBAR'
export const CLOSE_SNACKBAR = 'horizon/snackbar/CLOSE_SNACKBAR'
export const AUTH_SUCCESS = 'horizon/profile/AUTH_SUCCESS'
export const SET_AGENT_BUSINESS_UNIT = 'horizon/profile/SET_AGENT_BUSINESS_UNIT'
export const LOGOUT = 'horizon/profile/LOGOUT'


// WEBPACK FOOTER //
// ./src/core/duck/types.ts